module.exports = __webpack_public_path__ + "static/media/vauxhall-go-drive.82619114.png";